import { embeddingService } from '../services/embedding';
import { logger } from '../utils/logger';

logger.info('Offscreen document loaded');

chrome.runtime.onMessage.addListener((message, sender, sendResponse) => {
  if (message.type === 'generateEmbedding') {
    (async () => {
      try {
        const embedding = await embeddingService.generateEmbedding(message.text);
        sendResponse({ success: true, embedding });
      } catch (error: any) {
        const msg: string = error?.message ?? String(error);
        const stack: string = error?.stack ?? '';
        logger.error(`[Offscreen] Embedding generation error: ${msg}${stack ? `\n${stack}` : ''}`);
        sendResponse({ success: false, error: msg });
      }
    })();
    return true; // Keep the message channel open for async response
  }

  if (message.type === 'generateEmbeddings') {
    (async () => {
      try {
        const embeddings = await embeddingService.generateEmbeddings(message.texts);
        sendResponse({ success: true, embeddings });
      } catch (error: any) {
        const msg: string = error?.message ?? String(error);
        const stack: string = error?.stack ?? '';
        logger.error(`[Offscreen] Batch embedding generation error: ${msg}${stack ? `\n${stack}` : ''}`);
        sendResponse({ success: false, error: msg });
      }
    })();
    return true;
  }
});
